import React, { MouseEvent } from "react";
import classNames from "classnames";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { SplitSIcon } from "@icons";
import styles from "./TransactionSplitColumnContent.module.scss";

interface Props {
    transaction: TransactionListItem;
    onClick?: (event: MouseEvent) => void;
    hasAdjacentSplitSibling?: boolean;
    // New props for more explicit control
    hasTopSibling?: boolean;
    hasBottomSibling?: boolean;
}

export const TransactionSplitColumnContent: React.FC<Props> = ({
    transaction,
    onClick,
    hasAdjacentSplitSibling,
    hasTopSibling,
    hasBottomSibling,
}) => {
    const isSplit = transaction.splitParentId !== null;

    if (!isSplit) {
        return null;
    }

    // For backward compatibility, if new props aren't provided, use the old prop
    const showBottomLine = hasBottomSibling ?? hasAdjacentSplitSibling;
    const showTopLine = hasTopSibling ?? false;

    return (
        <div className={styles.content}>
            <div
                className={classNames(styles.splitButtonContainer, {
                    [styles.splitButtonContainerAdjacentSibling]:
                        showBottomLine,
                    [styles.splitButtonContainerWithTopLine]: showTopLine,
                })}
            >
                <Tooltip content={onClick ? "View split" : undefined}>
                    <Button
                        variant="secondary"
                        size="sm"
                        iconOnly
                        aria-label="View split"
                        aria-hidden={onClick ? undefined : true}
                        tabIndex={onClick ? undefined : -1}
                        className={styles.splitButton}
                        onClick={onClick}
                        disabled={!onClick}
                    >
                        <SplitSIcon />
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
};
